<template>
  <button
    :class="[
      'botao-padrao',
      { 'arredondado-esquerda': arredondadoEsquerda },
      { 'arredondado-direita': arredondadoDireita },
      { arredondado: arredondado },
      { desabilita: desabilita },
      cor ? cor : ''
    ]"
    :disabled="desabilita"
  >
    {{ nome.toUpperCase() }}
  </button>
</template>

<script>
export default {
  name: "BotaoTipoNome",
  props: {
    desabilita: Boolean,
    arredondadoEsquerda: Boolean,
    arredondadoDireita: Boolean,
    arredondado: Boolean,
    nome: String,
    cor: String
  }
};
</script>

<style lang="scss" scoped>
.botao-padrao {
  text-decoration: none;
  transition: all 0.3s ease;
  height: 30px;
  padding: 5px 10px 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cinza2);
  color: var(--branco);
  font-family: "Roboto Condensed";
  white-space: nowrap;
  box-shadow: 2px 2px 4px var(--sombra2);
  &:hover {
    background: var(--cinza3);
  }
  &:focus {
    background: var(--cinza1);
  }
}
.arredondado {
  border-radius: 50px;
}
.arredondado-esquerda {
  border-radius: 50px 0 0 50px;
  padding: 5px 7px 5px 12px;
}
.arredondado-direita {
  border-radius: 0 50px 50px 0;
  padding: 5px 12px 5px 7px;
}
.verde {
  background: var(--verde2);
  &:hover {
    background: var(--verde3);
  }
  &:focus {
    background: var(--verde1);
  }
}
.vermelho {
  background: var(--vermelho2);
  &:hover {
    background: var(--vermelho3);
  }
  &:focus {
    background: var(--vermelho1);
  }
}
.azul {
  background: var(--azul2);
  &:hover {
    background: var(--azul3);
  }
  &:focus {
    background: var(--azul1);
  }
}
.laranja {
  background: var(--laranja2);
  &:hover {
    background: var(--laranja3);
  }
  &:focus {
    background: var(--laranja1);
  }
}
.desabilita {
  opacity: 0.5;
  filter: saturate(0.4) contrast(0.4) brightness(1.2);
}
</style>
